import { PrimaryButton } from "@/components/common/PrimaryButton";
import { Box, Paper, Typography } from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';

export function WarningNoContract() {
    return (
        <Paper elevation={0} sx={{
            p: 3,
            mt: 2,
            border: '1px solid #e0e0e0',
            borderRadius: 2,
            bgcolor: '#f9f9f9',
            textAlign: 'center'
        }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <LockIcon sx={{ fontSize: 48, color: 'gray.500' }} />
                <Typography variant="h6" color="text.primary">
                    Análise de Atendimento com IA não disponível!
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '600px', mx: 'auto' }}>
                    Você precisa ativar as funcionalidades de Análise de Atendimento com IA na área de extensões:
                    Relatório Médico, Discussão de Casos ou Orientação ao Paciente.
                </Typography>
                <PrimaryButton
                    onClick={() => window.location.href = '/portal/#/extensions'}
                    width="100%"
                    height="40px"
                >
                    Adquirir Extensões
                </PrimaryButton>
            </Box>
        </Paper>
    )
}